import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* Page imports */
import Home from './pages/Home';
import SignUp from './pages/Signup';
import Portal from './pages/Portal';
import Case from './pages/Case';
import PrivateRoute from './utils/PrivateRoute';
import Profile from './pages/Profile';
import IfLoggedIn from './utils/IfLoggedInRoute';
import Cases from './pages/Cases';
import Settings from './pages/Settings';
import UserSupport from './pages/UserSupport';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Feedback from './pages/Feedback';
import SubjectFeedback from './pages/SubjectFeedback';
import Results from './pages/Results';
import ChallengeResult from './pages/ChallengeResult';
import Evaluation from './pages/Evaluation';
import MoodOverviewSubject from './pages/MoodOverviewSubject';
import ScorePage from './pages/ScorePage';
import IndScorePage from './pages/Score';
import MoodQuestion from './pages/MoodQuestion';
import UserStory from './pages/UserStory';
import LevelPage from './pages/LevelPage';
import MoodOverviewAll from './pages/MoodOverviewAll';
import AllChallenges from './pages/AllChallenges';
import WelcomeScreen from './pages/WelcomeScreen';

setupIonicReact();

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet>
        <IfLoggedIn component={Home} exact path="/home" />
        <IfLoggedIn component={Home} exact path="/" />
        <IfLoggedIn component={SignUp} exact path="/signup" />
        <PrivateRoute component={Settings} exact path="/settings" />
        <PrivateRoute component={UserSupport} exact path="/usersupport" />
        <Route component={PrivacyPolicy} exact path="/privacy" />
        <PrivateRoute component={Cases} exact path="/cases" />
        <PrivateRoute component={Feedback} exact path="/feedback" />
        <PrivateRoute component={SubjectFeedback} exact path="/subjectfeedback" />
        <PrivateRoute component={Portal} exact path="/portal" />
        <PrivateRoute component={Profile} exact path="/Profile" />
        <PrivateRoute component={Results} exact path="/results" />
        <PrivateRoute component={Case} exact path="/case" />
        <PrivateRoute component={Evaluation} exact path="/evaluation" />
        <PrivateRoute component={ChallengeResult} exact path="/challengeresult" />
        <PrivateRoute component={MoodOverviewSubject} exact path="/moodOverviewSubject" />
        <PrivateRoute component={ScorePage} exact path="/ScorePage" />
        <PrivateRoute component={IndScorePage} exact path="/Score" />
        <PrivateRoute component={MoodQuestion} exact path="/moodQuestion" />
        <PrivateRoute component={UserStory} exact path="/userStory" />
        <PrivateRoute component={LevelPage} exact path="/LevelPage" />
        <PrivateRoute component={MoodOverviewAll} exact path="/moodOverviewAll" />
        <PrivateRoute component={AllChallenges} exact path="/AllChallenges" />
        <PrivateRoute component={WelcomeScreen} exact path="/WelcomeScreen" />
      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
);

export default App;
